import { WithdrawalStore } from "@state/stores/payment/withdrawal";
import { createContext } from "react";

//@ts-expect-error
export const WithdrawalContext = createContext<WithdrawalStore>(null);
